import { useCallback, useEffect, useState } from "react"
import { useCopyToClipboard } from "usehooks-ts"
import { Connector, useAccount } from "wagmi"

export const useEffectOnce = (callback: () => void) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => callback(), []) // we only run this hook on mount
}

export const useCopyValue = (value: string | null, label: string) => {
  const [copyLabel, setCopyLabel] = useState(label)

  const [_, copy] = useCopyToClipboard()

  const copyValueHandler = useCallback(() => {
    if (!value) return

    copy(value)
    setCopyLabel("Copied")

    setTimeout(() => setCopyLabel(label), 1000)
  }, [copy, value, label])

  return { label: copyLabel, copy: copyValueHandler }
}

export const useMutationObserver = (
  target: Node | null,
  callback: () => void,
  config?: MutationObserverInit,
) => {
  useEffect(() => {
    callback()

    const observer = new MutationObserver(callback)

    if (target) {
      observer.observe(target, config)
    }

    return () => {
      observer.disconnect()
    }
  }, [target, config, callback])
}

type ConnectorWithMetadata = Connector & {
  rkDetails: {
    // RainbowKit sets this by checking window.isTally
    installed: boolean
  }
}

/**
 * Checks if user has connected with Taho wallet, it's not enough to check
 * if connector id matches since wagmi fallbacks to window.ethereum for
 * injected providers
 */
export const useIsTahoWallet = () => {
  const { connector } = useAccount()

  return (
    connector?.id === "taho" &&
    (connector as ConnectorWithMetadata).rkDetails?.installed
  )
}
